import { graphql } from '@search/gql-client/src';

export const AgentEditFavoriteMutation = graphql`
    mutation AgentEditFavoriteMutation(
        $offerId: ID!
        $isFavorite: Boolean!
        $customerId: ID!
    ) {
        businessEditFavorite(isFavorite: $isFavorite, customerId: $customerId, offerId: $offerId)
    }
`;
